/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown> }} Progress_Streak_LabelInputs */

const en_us2_progress_streak_label = /** @type {(inputs: Progress_Streak_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`week in a row on plan`);
	return /** @type {LocalizedString} */ (`weeks in a row on plan`)
	
};

const pt_br2_progress_streak_label = /** @type {(inputs: Progress_Streak_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`semana seguida no plano`);
	return /** @type {LocalizedString} */ (`semanas seguidas no plano`)
	
};

const es_419_progress_streak_label = /** @type {(inputs: Progress_Streak_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`semana seguida cumpliendo el plan`);
	return /** @type {LocalizedString} */ (`semanas seguidas cumpliendo el plan`)
	
};

const pt_pt2_progress_streak_label = /** @type {(inputs: Progress_Streak_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`semana seguida no plano`);
	return /** @type {LocalizedString} */ (`semanas seguidas no plano`)
	
};

const fr_fr2_progress_streak_label = /** @type {(inputs: Progress_Streak_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`semaine d'affilée selon le programme`);
	return /** @type {LocalizedString} */ (`semaines d'affilée selon le programme`)
	
};

const de_de2_progress_streak_label = /** @type {(inputs: Progress_Streak_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`Woche am Stück nach Plan`);
	return /** @type {LocalizedString} */ (`Wochen am Stück nach Plan`)
	
};

const it_it2_progress_streak_label = /** @type {(inputs: Progress_Streak_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`settimana di fila in linea con la scheda`);
	return /** @type {LocalizedString} */ (`settimane di fila in linea con la scheda`)
	
};

/**
* | weeks | output |
* | --- | --- |
* | "1" | "week in a row on plan" |
* | * | "weeks in a row on plan" |
*
* @param {Progress_Streak_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_streak_label = /** @type {((inputs: Progress_Streak_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Streak_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_streak_label(inputs)
	if (locale === "es-419") return es_419_progress_streak_label(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_streak_label(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_streak_label(inputs)
	if (locale === "de-DE") return de_de2_progress_streak_label(inputs)
	if (locale === "it-IT") return it_it2_progress_streak_label(inputs)
	return en_us2_progress_streak_label(inputs)
});
export { progress_streak_label as "progress.streak_label" }